import { defineMessages } from 'react-intl'

export default defineMessages({
  links: {
    id: 'containers.EmbeddedCompanyPage.components.Brand.links',
    defaultMessage: 'Company dashboard CTA buttons',
  },
  linksHint: {
    id: 'containers.EmbeddedCompanyPage.components.Brand.links.hint',
    defaultMessage: 'Customize the two call-to-action buttons on the company dashboard. Hint: If you want a button to be an e-mail trigger, you can fill set the link to something like "mailto:johndoe@voicearchive.com", replacing "johndoe" with your e-mail handle.',
  },
})
